import { Fragment, useEffect, useMemo, useState } from 'react';
import { Dashboard, logo_card, noData } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Input, Pagination } from 'antd';

import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import { ICustomerFields } from '../../../api/salesSericeCustomer/salesSericeCustomerApi';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import { getWidthFromHeader, renderValueAsJSX } from '../../../until';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import StatusCellRenderer from '../../VehicleManagement/VehicleTypeManagement/Component/StatusCellRenderer';
import TabsFeilds from '../Modal/TabsFeilds';
dayjs.locale('vi');

const { RangePicker } = DatePicker;


const dataListFieldsByCustomerRecordActive = [
  {
    "id": 1,
    "title": "Hoá đơn bảo trì dịch vụ",
    "fields": [
      {
        "id": 1,
        "fieldCode": "contractCode",
        "fieldLabel": "Mã HĐKD",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 2,
        "fieldCode": "serviceType",
        "fieldLabel": "Loại hình SC",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 3,
        "fieldCode": "currentKm",
        "fieldLabel": "Số Km hiện tại",
        "inputType": "number",
        "isActive": 1
      },
      {
        "id": 4,
        "fieldCode": "repairDate",
        "fieldLabel": "Ngày sửa chữa",
        "inputType": "date",
        "isActive": 1
      },
      {
        "id": 5,
        "fieldCode": "deliveryDate",
        "fieldLabel": "Ngày giao xe",
        "inputType": "date",
        "isActive": 1
      },
      {
        "id": 6,
        "fieldCode": "content",
        "fieldLabel": "Nội dung",
        "inputType": "string",
        "isActive": 1
      },
      {
        "id": 7,
        "fieldCode": "total",
        "fieldLabel": "Tổng tiền",
        "inputType": "number",
        "isActive": 1
      },
      {
        "id": 8,
        "fieldCode": "laborRevenue",
        "fieldLabel": "Doanh thu công lao động",
        "inputType": "number",
        "isActive": 1
      },
      {
        "id": 9,
        "fieldCode": "partsRevenue",
        "fieldLabel": "Doanh thu vật tư phụ tùng",
        "inputType": "number",
        "isActive": 1
      }
    ]


  }
]

const dataListFieldsByCustomerRecordNotActive = [
  {
    "id": 1,
    "title": "Hoá đơn bảo trì dịch vụ",
    "fields": [
    ]
  }
]

const rowData = [
  {
    contractCode: "SR-CVB",
    serviceType: "BDĐK",
    currentKm: 2235,
    repairDate: "21/02/2022",
    deliveryDate: "21/02/2022",
    content: "Bảo dưỡng định kỳ (T)",
    total: 2500000000,
    laborRevenue: 2500000000,
    partsRevenue: 0
  },
  {
    contractCode: "SR-001",
    serviceType: "Sửa chữa",
    currentKm: 10500,
    repairDate: "15/03/2022",
    deliveryDate: "16/03/2022",
    content: "Thay dầu, cân chỉnh phanh",
    total: 3500000,
    laborRevenue: 1500000,
    partsRevenue: 2000000
  },
  {
    contractCode: "SR-002",
    serviceType: "BDĐK",
    currentKm: 5000,
    repairDate: "10/04/2022",
    deliveryDate: "10/04/2022",
    content: "Bảo dưỡng 5.000km",
    total: 2500000,
    laborRevenue: 1000000,
    partsRevenue: 1500000
  }
];





const generateColumnsFromCodesAgGridReact = (
  codes: ColumnKey[],
  fields: ICustomerFields[],
  actionColumn?: ColDef<any, any>,
  onToggleStatus?: (id: number, next: boolean, rowData: any) => void, // thêm callback
): ColDef[] => {
  const baseColumns = codes
    ?.map(code => {
      const field = fields.find(f => f.fieldCode === code)
      if (!field) return null
      if (field.fieldCode === "status") {
        return {
          headerName: field.fieldLabel,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          resizable: true,
          filter: true,
          cellRenderer: StatusCellRenderer,
          cellRendererParams: {
            onToggle: (id: number, next: boolean, rowData: any) => {
              if (onToggleStatus) {
                onToggleStatus(id, next, rowData)
              }
            },
            idKey: 'key'
          }
        }
      }

      return {
        headerName: field.fieldLabel,
        field: field.fieldCode,
        colId: field.fieldCode,
        sortable: true,
        editable: true,
        resizable: true,
        // filter: true,
        // width: getWidthFromHeader(field.fieldLabel),
        cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
      } as ColDef
    })
    .filter(Boolean) as ColDef[]

  return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
}

export default function ServiceMaintenanceInvoiceDetail({ stData = {} as any }) {

  const pushToast = useToast();

  const [isSettingShow, setSettingShow] = useState(false)

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

  const [demoList, setDemoList] = useState<any[]>([])
  const [rowHeight, setRowHeight] = useState(40)

  useEffect(() => {
    gListFieldsActive()
    gList()


    const handleResize = () => {
      const baseFactor = (48 * 100) / 1440 / 100
      const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
      const newHeight = Math.round(window.innerWidth * factor)
      setRowHeight(newHeight)
    }
    handleResize()

    window.addEventListener('resize', handleResize)

    return (() => {
      // setPagination({ current: 1, pageSize: 20, total: 0 })
      // setSelectedRowKeys([])
      window.removeEventListener('resize', handleResize)
    })
  }, [])

  const gList = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    setDemoList(rowData)
  }, 1000)


  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    // width: getWidthFromHeader('Hành động'),
    cellRenderer: (params: any) => {
      // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>

          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
          // onClick={() => gInfoVehicleModel(id)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
          // onClick={() => gInfoVehicleModel(id, false)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
          // onClick={() => openModalDelete(Number(id))}
          />

        </div>

      )
    },
  }


  const gListFieldsActive = async () => {
    const flattenedFields = await dataListFieldsByCustomerRecordActive.flatMap(choice =>
      choice.fields.map(field => ({
        ...field,
        parentId: choice.id,
      }))
    );
    setDataFilterActive(flattenedFields)


    gListFieldsNotActive()
  }
  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive)


  }
  const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setDataFilterActive(dataFilterActive ?? [])
      setDataFilterNoActive(dataFilterNoActive ?? [])
      gList()

    } else {
      pushToast(message, "warning")
    }
  }

  const onCloseDataFields = () => {
    setSettingShow(false)
  }

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      ColumnsMapShow, dataFilterActive, actionColumn,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)

    );
  }, [ColumnsMapShow]);

  useEffect(() => {
    const codes = dataFilterActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFilterActive])

  return (
    <Fragment>
      {
        isSettingShow ?
          <TabsFeilds
            isSettingShow={isSettingShow}
            dataFilterActive={dataFilterActive}
            dataFilterNoActive={dataFilterNoActive}

            onSaveDataFields={onSaveDataFields}
            onClose={onCloseDataFields}
          /> :
          null
      }
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="w-full flex items-center justify-end">

          <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
              onClick={() => setSettingShow(true)}
            >
              <SettingOutlined />
            </div>
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer">
              <MoreOutlined />
            </div>

          </div>
        </div>
        <div className={` w-full`}>
          <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
            <AgGridReact<any>
              rowData={stData.chitietdichvu || []}
              columnDefs={[
                { field: "own_accu_seri", headerName: "AccSeri1" },
                { field: "own_accu_seri1", headerName: "AccuSeri2" },
                { field: "own_branch_name", headerName: "Đơn vị" },
                { field: "own_chassis_no", headerName: "Số khung" },
                { field: "own_color_name", headerName: "Màu xe" },
                { field: "own_engine_no", headerName: "Số máy" },
                { field: "own_made_year", headerName: "Năm sản xuất" },
                { field: "own_number_plate", headerName: "Biển số" },
                { field: "own_purchase_date", headerName: "Ngày mua" },
                { field: "own_route_name", headerName: "Chi nhánh" },
                { field: "own_vehicle_brand", headerName: "Hãng xe" },
                { field: "own_vehicle_model", headerName: "Mẫu xe" },
                { field: "own_vehicle_name", headerName: "Tên xe" },
                { field: "repair_item_amount", headerName: "Doanh thu vật tư phụ tùng" },
                { field: "repair_total_amount", headerName: "Tổng doanh thu sửa chữa xe" }
              ]}
              defaultColDef={{
                resizable: true,
                sortable: true,
              }}
              domLayout="autoHeight"
              className="my-auto-height-grid"
              rowHeight={55}
              getRowStyle={(params: any) => ({
                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              overlayNoRowsTemplate={`
                           <div style="text-align: center; padding: 20px;">
                           <br />
                               <img src="${noData}" alt="No data" style="max-width: 150px;" />
                           <br />
                               <div>Không có dữ liệu</div>
                           <br />
                           </div>
                           `}
            />

          </div>
        </div>
      </div>
    </Fragment>
  )

}
